export const stepper = {
  steppanel: {
    background: '{rgba(0, 0, 0, 0)}',
  },
  steppanels: {
    padding: '0',
  },
}
